module.exports = __webpack_public_path__ + "8e1ed89b6ccb8ce41faf5cb672677105.woff2";